/**
 * 认证路由守卫
 * - 未登录或超 2 小时 → 重定向到 /login
 * - 登录后若需强制改密则重定向到 /change-password
 * - 超时消息通过 URL query 参数 ?reason=expired 传给 LoginPage 显示
 */
import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

export function AuthGuard(): JSX.Element {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const mustChangePassword = useAuthStore((s) => s.mustChangePassword);

  if (!isAuthenticated) {
    // 超 2h → 传 reason=expired
    return <Navigate to="/login?reason=expired" replace />;
  }

  if (mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
}

export default AuthGuard;
